export default __webpack_public_path__ + "static/media/pie-chart.425e938e.svg";